// src/components/layouts/ReviewerLayout.jsx
import React from 'react';
import AuthorHeader from './AuthorHeader';
import { Outlet } from 'react-router-dom';
import ReviewerSidebar from './ReviewerSidebar';

const ReviewerLayout = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      <ReviewerSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <AuthorHeader />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ReviewerLayout;